import React from 'react';
import GrammarPageLayout from '../components/grammar-page-layout';
import GrammarExplanation from '../components/explanations/so-enough-explanation';

const mainimage = '/Images/enough1.webp';

const sections = [
  { label: "Grammar", description: "Do this exercise to practice grammar.", type: "quiz", subtype: "soenough" },
];

const Soenough = () => (
  <GrammarPageLayout
    level="B1"
    title="Soenough"
    image={mainimage}
    ExplanationComponent={GrammarExplanation}
    sections={sections}
    seoTitle="Free English “So” and “Enough” Exercises"
    seoDescription="Express degree and sufficiency with so, such, enough, too. B2 level practice."
    relatedCategory="grammar-exercises"
    relatedLevel="B2"
  />
);

export default Soenough;

